<template>
    <form @submit.prevent="performLogin" class="login-form">

        <div class="form-group form-group-feedback form-group-feedback-left">
            <input v-model="proxyEmail" :class="{'is-invalid': hasError}" type="email" autocomplete="email" class="form-control" :placeholder="$t('auth.email')" required>
            <div class="form-control-feedback">
                <i class="icon-user text-muted"></i>
            </div>
        </div>

        <div class="form-group form-group-feedback form-group-feedback-left">
            <input v-model="proxyPassword" :class="{'is-invalid': hasError}" type="password" autocomplete="password" class="form-control" :placeholder="$t('auth.password')" required >
            <div class="form-control-feedback">
                <i class="icon-lock2 text-muted"></i>
            </div>
        </div>

        <div v-if="hasError" class="alert bg-danger text-white">
            <span class="font-weight-semibold">{{errorMessage || $t('auth.log_in_error')}}</span>
        </div>

        <div class="form-group">
            <button v-if="isAuthenticated"
                    type="button"
                    disabled="disabled"
                    class="btn btn-success btn-block">
                {{$t('auth.redirecting')}}
                <i class="fa fa-circle-o-notch fa-spin ml-2"></i>
            </button>
            <button v-else-if="!isLoading"
                    type="submit"
                    class="btn btn-primary btn-block pt-2 pb-2 line-height-1">
              {{$t('auth.log_in')}}
                <fa-icon icon="arrow-alt-circle-right" class="ml-2"></fa-icon>
            </button>
            <button v-else
                    disabled="disabled"
                    type="button"
                    class="btn btn-primary btn-block pt-2 pb-2 line-height-1">
              {{$t('auth.wait')}} <fa-icon icon="circle-notch" class="ml-2 fa-spin"></fa-icon>
            </button>
        </div>

        <div class="text-center">
            <router-link
                :disabled="isLoading || isAuthenticated"
                :to="{name: 'ResetPassword', query: {email: this.proxyEmail}}"
                class="btn btn-link"
                tag="button"
            >
              {{$t('auth.forgot_your_password')}}
            </router-link>
        </div>

    </form>
</template>

<script>
    import {mapGetters, mapState} from "vuex";

    export default {
        name: "LoginForm",
        props: ['email'],

        data: () => ({
            proxyEmail: '',
            proxyPassword: ''
        }),

        watch: {
            email: {
                immediate: true,
                handler() {
                    this.proxyEmail = this.email;
                }
            }
        },

        computed: {
            ...mapState('Auth', ['isAuthenticated', 'isLoading']),
            ...mapGetters('Auth', ['hasError', 'errorMessage']),
        },

        methods: {
            performLogin () {
                let payload = { email: this.proxyEmail, password: this.proxyPassword };
                this.$store.dispatch('Auth/login', payload);
            }
        }
    }
</script>
